module.exports = require('./lib');



//////////////////
// WEBPACK FOOTER
// /produit/nodejs/bin/node-v14.19.0-linux-x64/lib/~/rc-datepicker/index.js
// module id = 110
// module chunks = 0